import { render } from "./ProductDisplay.vue?vue&type=template&id=19f043c1&scoped=true"
import script from "./ProductDisplay.vue?vue&type=script&lang=js"
export * from "./ProductDisplay.vue?vue&type=script&lang=js"

import "./ProductDisplay.vue?vue&type=style&index=0&id=19f043c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f043c1"]])

export default __exports__